import type { SVGProps } from 'react';

const SvgPlayerLoop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M8.02 16.988c.55 0 1-.45 1-1s-.45-1-1-1c-1.65 0-3-1.35-3-3s1.35-3 3-3h8c1.65 0 3 1.35 3 3s-1.35 3-3 3h-1.59l1.29-1.29a.996.996 0 0 0-.71-1.7c-.26 0-.51.1-.71.29l-3 3a.996.996 0 0 0 0 1.41l3 3a.996.996 0 1 0 1.41-1.41l-1.29-1.29h1.59c2.76 0 5-2.24 5-5s-2.24-5-5-5h-8c-2.76 0-5 2.24-5 5s2.24 5 5 5z"
    />
  </svg>
);
export default SvgPlayerLoop;
